import script from "./TestSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestSettingsView.vue?vue&type=script&setup=true&lang=js"

import "./TestSettingsView.vue?vue&type=style&index=0&id=b5caaf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5caaf46"]])

export default __exports__